import { Action } from 'redux';
import { initializeState } from 'src/utils/Initial';
import { isType } from 'typescript-fsa';
import * as Actions from '../actions/exercise';

/**
 * 課題提出画面のState型
 */
export interface IExerciseState {
	readonly tasks: Actions.ITask[];
}

/**
 * 課題提出画面のState初期値
 */
const initialState: IExerciseState = {
	tasks: [],
};

/**
 * 課題提出画面用reducer
 * @param state State
 * @param action アクション
 */
const exercise = (state: IExerciseState, action: Action) => {
	if (!state) {
		// State初期化処理
		state = initialState;
		state = initializeState(state);
	}
	if (isType(action, Actions.setTitle)) {
		return {
			...state,
			careerTitle: action.payload.careerTitle,
			classTitle: action.payload.classTitle,
		};
	}

	if (isType(action, Actions.setTasks)) {
		return {
			...state,
			tasks: action.payload.tasks,
		};
	}

	if (isType(action, Actions.clearExerciseParams)) {
		return initialState;
	}

	return state;
};

export default exercise;



// WEBPACK FOOTER //
// ./src/reducers/exercise.ts